"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryWrapper = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const UI_1 = require("../ui/UI");
function isNotEmptyData(data) {
    if (Array.isArray(data)) {
        return data.length > 0;
    }
    if (data && typeof data === "object") {
        return Object.keys(data).length > 0;
    }
    return data !== null && data !== undefined;
}
function QueryWrapper(_a) {
    var { children, data } = _a, props = tslib_1.__rest(_a, ["children", "data"]);
    const { loading, error, noData } = props;
    const { useLoader, useErrorAlert, useWarningAlert } = UI_1.useUIContext();
    const { loader, setLoading } = useLoader({ loading });
    const { warningAlert, setWarningAlert } = useWarningAlert();
    const { errorAlert, setErrorAlert } = useErrorAlert();
    const [childrenData, setChildrenData] = react_1.useState();
    react_1.useEffect(() => {
        setLoading(loading);
        setErrorAlert(!loading && error ? error : undefined);
        let displayChildren = undefined;
        const hasData = isNotEmptyData(data);
        if (data && hasData && !loading && !error) {
            displayChildren = children(Object.assign({ data,
                setLoading,
                setErrorAlert,
                setWarningAlert }, props));
        }
        setChildrenData(displayChildren);
        setWarningAlert(error || loading || !noData || hasData ? undefined : noData);
    }, [loading, error, data]);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [loader, errorAlert, warningAlert, childrenData] }, void 0));
}
exports.QueryWrapper = QueryWrapper;
//# sourceMappingURL=QueryWrapper.js.map